export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

export function handleResponse(response) {
    return response.json().then(text => {
        const data = text;
        if (!response.ok) {
            if (response.status === 401 && data && data.emailVerified === false) {
                return Promise.reject({ emailUnverified: true, message: data.message });
            }
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });


}

function logout() {
    // remove user from local storage to log user out
    localStorage.clear();
}